import React from 'react'
import { Modal } from 'react-bootstrap'
import PdfUploader from '../../Components/PdfUploader'

const SocialReportModal = ({showModal, closeModal, email, setIsSent}) => {
  return (
    <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
            Please upload Social Media Report
        </Modal.Header>
        <Modal.Body>
             <PdfUploader email={email} setIsSent={setIsSent} closeModal={closeModal} />
        </Modal.Body>
      
    </Modal>
  )
}

export default SocialReportModal
